import classNames from 'classnames';
import { Button } from 'flowbite-react';
import React from 'react';
import { AiOutlinePlus } from 'react-icons/ai';
import { Img } from 'react-image';

interface Props {
	title?: string;
	description?: string | null;
	showAction?: boolean;
	buttonText?: string;
	onClick?: () => void;
	titleCss?: string;
}

const NoRecruiterPositionsContainer = ({
	showAction = true,
	onClick,
	title,
	description,
	buttonText,
	titleCss,
}: Props) => {
	return (
		<>
			<div className="flex flex-col items-center justify-center">
				<div className="px-8">
					<div className="flex justify-center">
						<Img
							loading="lazy"
							src="/assets/noApplicationsEmptyState.svg"
							alt="noApplicationsEmptyState"
							width="160"
							height="160"
						/>
					</div>

					<div className={classNames('text-center mt-4 text-base font-medium', titleCss)}>
						{title || 'No active job positions'}
					</div>
					{description !== null ? (
						<div className="text-center mt-2 text-sm font-normal text-[#28293D] dark:text-[#C7C9D9]">
							{description || 'Publish your first job posting and get personalised recommendation in minutes.'}
						</div>
					) : null}

					{showAction ? (
						<div className="flex justify-center mt-5">
							<Button color="purplePlaced" onClick={onClick}>
								<AiOutlinePlus className="mr-2" />
								{buttonText || 'Post a job'}
							</Button>
						</div>
					) : null}
				</div>
			</div>
		</>
	);
};

export default NoRecruiterPositionsContainer;
